import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { InfoBox } from './InfoBox';
import { Button } from 'src/domains/common/components/button/button';
import { CampaignModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/CampaignModel';
import { PopupsStackState } from 'src/AppState/PopupsStackState';
import { useAppStateContext } from 'src/AppState/AppState';

interface PromotionDetailsType {
    campaignModel: CampaignModel;
}

export const GeneralDetails = observer('GeneralDetails', ({ campaignModel }: PromotionDetailsType) => {
    const { common } = useAppStateContext();
    const popupsStack = PopupsStackState.get(common);

    return (
        <InfoBox>
            <h3 className='m-0 mb-4 text-base font-semibold'>General Details</h3>
            <div className='flex gap-8'>
                <div className='w-1/2'>
                    <div className='flex flex-col'>
                        <h4 className='text-sm m-0 mb-2 font-semibold'>Basic Information</h4>
                        <div className='mb-3'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Campaign Type</h5>
                            <span className='text-sm'>{campaignModel.campaignType}</span>
                        </div>
                        <div className='relative'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Terms & Conditions</h5>
                            <p
                                className='m-0 overflow-hidden line-clamp-6 text-sm'
                                dangerouslySetInnerHTML={{ __html: campaignModel.description }}
                            />
                            <div className='absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-white to-transparent pointer-events-none' />
                        </div>

                        <div
                            onClick={() =>
                                popupsStack.addPopup('terms', {
                                    hasOverlay: true,
                                    template: 'generic',
                                    title: 'Terms & Conditions',
                                    confirm_label: 'Done',
                                    dialogClassName: 'max-w-[800px] w-full',
                                    message: (
                                        <div className='bg-muted/80 rounded-[4px] p-[12px] mt-[10px] max-h-[380px] max-w-[752px] overflow-y-scroll  custom-scrollbar'>
                                            <p
                                                className='m-0 text-foreground'
                                                dangerouslySetInnerHTML={{ __html: campaignModel.description }}
                                            />
                                        </div>
                                    ),
                                    onCancel: () => {
                                        popupsStack.closePopupOnTop();
                                    },
                                    onConfirm: () => {
                                        popupsStack.closePopupOnTop();
                                    },
                                })
                            }
                        >
                            <Button
                                icon='expand'
                                size='default'
                                variant='ghost'
                            >
                                Expand
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='w-1/2'>
                    <div className='flex flex-col'>
                        <h4 className='text-sm m-0 mb-2 font-semibold'>Campaign Time Period</h4>
                        <div className='mb-3'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Start</h5>
                            <span className='text-sm'>Custom</span>
                        </div>
                        <div className='mb-4 flex gap-2'>
                            <div className='w-1/2'>
                                <h5 className='m-0 text-xs text-muted-foreground font-normal'>
                                    Start Date & Time (UK Time)
                                </h5>
                                <span className='m-0 text-sm'>
                                    {campaignModel.startTime?.format('DD/MM/YYYY | HH:mm')}
                                </span>
                            </div>
                            <div className='w-1/2'>
                                <h5 className='m-0 text-xs text-muted-foreground font-normal'>
                                    End Date & Time (UK Time)
                                </h5>
                                <span className='m-0 text-sm'>
                                    {campaignModel.endTime?.format('DD/MM/YYYY | HH:mm')}
                                </span>
                            </div>
                        </div>
                        <h4 className='text-sm m-0 mb-2 font-semibold'>Frequency</h4>
                        <div className='mb-3'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>Usage Frequency</h5>
                            <span className='text-sm'>{campaignModel.frequencyPeriod ?? '-'}</span>
                        </div>
                        <div className='mb-3'>
                            <h5 className='m-0 text-xs text-muted-foreground font-normal'>
                                Number of Uses in Frequency
                            </h5>
                            <span className='text-sm'>{campaignModel.numberOfUses ?? '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </InfoBox>
    );
});
